/* Carousels and reel controls for the training-aids advertorial. */
(function () {
  if (window.__taBooted) return;
  window.__taBooted = true;
  function initCarousel(root) {
    var track = root.querySelector('.ta-carousel__track');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var dots = root.querySelector('[data-ta-dots]');
    if (!track || slides.length < 2) {
      if (dots) dots.hidden = true;
      return;
    }
    var index = 0;
    var timer = null;
    var interval = parseInt(root.dataset.autoplay || '0', 10);

    function isCarousel() {
      return getComputedStyle(track).display === 'flex';
    }

    function render() {
      if (!isCarousel()) {
        track.style.transform = '';
        if (dots) dots.hidden = true;
        return;
      }
      if (dots) dots.hidden = false;
      track.style.transform = 'translateX(' + -index * 100 + '%)';
      if (dots) {
        Array.prototype.forEach.call(dots.children, function (b, i) {
          b.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }
    }

    function go(i) {
      index = (i + slides.length) % slides.length;
      render();
    }

    if (dots) {
      dots.innerHTML = '';
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () {
          go(i);
          stop();
        });
        dots.appendChild(b);
      });
    }

    function start() {
      if (!interval || timer) return;
      timer = setInterval(function () {
        if (isCarousel()) go(index + 1);
      }, interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    // Swipe.
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      x0 = null;
    });

    window.addEventListener('resize', render);
    render();
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  }

  function initReels(root) {
    initCarousel(root);
    var reels = root.querySelectorAll('.ta-reel');
    Array.prototype.forEach.call(reels, function (reel) {
      var video = reel.querySelector('video');
      var playBtn = reel.querySelector('[data-ta-play]');
      var muteBtn = reel.querySelector('[data-ta-mute]');
      var fullBtn = reel.querySelector('[data-ta-full]');
      if (!video) return;

      function sync() {
        var playing = !video.paused;
        reel.querySelector('.ta-icon-play').hidden = playing;
        reel.querySelector('.ta-icon-pause').hidden = !playing;
        if (playBtn) playBtn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        var muted = video.muted;
        reel.querySelector('.ta-icon-muted').hidden = !muted;
        reel.querySelector('.ta-icon-unmuted').hidden = muted;
        if (muteBtn) muteBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      }

      if (playBtn) playBtn.addEventListener('click', function () {
        if (video.paused) { video.play(); } else { video.pause(); }
      });
      if (muteBtn) muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        if (!video.muted && video.paused) video.play();
        sync();
      });
      if (fullBtn) fullBtn.addEventListener('click', function () {
        var fn = video.requestFullscreen || video.webkitEnterFullscreen || video.webkitRequestFullscreen;
        if (fn) fn.call(video);
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();
    });

    // Autoplay the reels on mobile, where Replo showed them playing.
    if (window.matchMedia('(max-width: 989px)').matches && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.5 });
      Array.prototype.forEach.call(root.querySelectorAll('.ta-reel video'), function (v) { io.observe(v); });
    }
  }

  function boot() {
    document.querySelectorAll('[data-ta-reels]').forEach(initReels);
    document.querySelectorAll('[data-ta-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-ta-faq]').forEach(function (root) {
      root.querySelectorAll('.ta-faq__q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (panel) panel.hidden = open;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
